import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getProjectVersions.query';

export const getStoredXerFileVersions = ({ projectId, contractId }: QueryParams) => {
    const querystring = qs.stringify(
        { contractId: contractId || -1, projectId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getStoredXerFileVersions${querystring}`;
    return network.get(url).then((response) => response.data);
};
